import { render, staticRenderFns } from "./category-types.vue?vue&type=template&id=3b75a45e&scoped=true"
import script from "./category-types.vue?vue&type=script&lang=js"
export * from "./category-types.vue?vue&type=script&lang=js"
import style0 from "./category-types.vue?vue&type=style&index=0&id=3b75a45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75a45e",
  null
  
)

export default component.exports